<template>
    <div>
        <card-header title="Payment Plans" icon="fa-money-check-alt"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Active Plans" icon="fa-play"/>
                <plan-tile
                    v-for="plan in user.payment_plans"
                    :card="card"
                    :plan="plan"
                    v-if="plan.paid < plan.total"
                    @click="$openCard('payment-plan', {planId: plan.id}, card)"
                    :active="(child && child.definition.component === 'payment-plan' && plan.id === parseInt(child.props.planId))"
                />

                <subheader-list-item title="Completed Plans" icon="fa-check"/>
                <plan-tile
                    v-for="plan in user.payment_plans"
                    :card="card"
                    :plan="plan"
                    v-if="plan.paid >= plan.total"
                    @click="$openCard('payment-plan', {planId: plan.id}, card)"
                    :active="(child && child.definition.component === 'payment-plan' && plan.id === parseInt(child.props.planId))"
                />

            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import PaymentPlanListItem from "../../components/PaymentPlanListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";

    import {client as http} from '@/http_client';
    import PlanTile from "../../components/tiles/PlanTile";

    export default {
        components: {PlanTile, CardHeader, CardBody, CardList, PaymentPlanListItem, SubheaderListItem},
        props: ['card', 'child', 'props'],
        data() {
            return {
                user: {}
            }
        },
        methods: {
            loadPlans: function() {
                this.$emit('loading', true);
                http.get('users/' + this.props.userId).then(response => {
                    this.user = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.loadPlans();
            }
        },

        mounted: function() {
            this.loadPlans();
        }
    }
</script>

<style lang="scss" scoped>

</style>
